import { useLocaleContext } from 'providers/LocaleProvider';
import React from 'react';
import { Title } from '@seaweb/coral/components/Typography';
import styled from 'styled-components';
import { string, number } from 'prop-types';
import Link from 'next/link';

const StyledCategoryBox = styled.a`
  width: 100%;
  margin: 20px 12px;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 4px 30px 0 rgba(102, 138, 184, 0.1);
  color: #202325;
  box-sizing: border-box;
  overflow: hidden;
  background: white;
  display: flex;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 31px 0 rgba(102, 138, 184, 0.2);
  }

  @media screen and (min-width: 1200px) {
    max-width: 552px;
  }

  @media screen and (max-width: 600px) {
    margin: 10px 0;
    min-height: 175px;
    padding: 20px 18px 20px 14px;
    align-items: flex-start;
  }

  @media screen and (min-width: 600px) {
    height: 219px;
  }
`;

const Description = styled.div`
  overflow: hidden;
  display: block;
  font-size: 16px;
  line-height: 27px;
  color: #202325;
  opacity: 0.6;
`;

const Count = styled.div`
  opacity: 0.3;

  @media screen and (max-width: 600px) {
    margin-top: 10px;
  }
`;

const CategoryTitle = styled(Title)`
  font-size: 24px;
  font-weight: bold;
  color: #202325;
  margin-bottom: 12px;
  height: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 600px) {
    font-size: 20px;
  }
`;

const DetailSection = styled.div`
  max-width: 312px;
  width: calc(100% - 98px);
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`;

const TextSection = styled.div`
  width: 100%;
  /* stylelint-disable declaration-block-no-duplicate-properties */
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  display: -webkit-box;
  margin-bottom: 16px;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 600px) {
    margin-bottom: 0;
    height: auto;
  }
`;

const CategoryImage = styled.img`
  width: 144px;
  height: 144px;
  margin-right: 28px;

  @media screen and (max-width: 600px) {
    height: 70px;
    width: 70px;
  }
`;

function CategoryBox({ img, name, description, articleCount, href }) {
  const { locale: t } = useLocaleContext();

  return (
    <Link href={href}>
      <StyledCategoryBox>
        <CategoryImage src={img} />
        <DetailSection>
          <TextSection>
            <CategoryTitle>{name}</CategoryTitle>
            <Description>{description}</Description>
          </TextSection>
          <Count>
            {t(
              articleCount > 1
                ? 'hc.homepage.article_count_template_plural'
                : 'hc.homepage.article_count_template',
              {
                count: articleCount,
              }
            )}
          </Count>
        </DetailSection>
      </StyledCategoryBox>
    </Link>
  );
}

CategoryBox.propTypes = {
  img: string.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  articleCount: number.isRequired,
  href: string.isRequired,
};

export default CategoryBox;
